import { ImportSuspectList } from './../models/import-suspect-list.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState } from '../state/app.state';
import { ImportSuspectListLine } from '../models/import-suspect-list-line.model';
import { take } from 'rxjs/operators';
import { RoutePlannerRequest } from '../models/routeplanner.model';
import { SuspectListDossier } from '../models/suspect-list-dossier.model';

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};
@Injectable({
  providedIn: 'root'
})
export class ImportSuspectService {

  constructor(
    private http: HttpClient,
    private appState: AppState,
  ) {}

  getImportLists(): Observable<ImportSuspectList[]> {
    return this.http.get<ImportSuspectList[]>(`${this.appState.baseApiUrl}/vermoedenslijst/import`, httpOptions);
  }

  getImportListById(id: number): Observable<ImportSuspectList> {
    return this.http.get<ImportSuspectList>(`${this.appState.baseApiUrl}/vermoedenslijst/import/${id}`, httpOptions);
  }

  getLinesByImportId(id: number): Observable<ImportSuspectListLine[]> {
    return this.http.get<ImportSuspectListLine[]>(`${this.appState.baseApiUrl}/vermoedenslijst/import/${id}/lines`, httpOptions);
  }

  getLineDossiersByImportId(id: number): Observable<SuspectListDossier[]> {
    return this.http.get<SuspectListDossier[]>(`${this.appState.baseApiUrl}/vermoedenslijst/import/${id}/lines-dossier`, httpOptions);
  }

  UpdateLine(importSuspectListLine: ImportSuspectListLine): Observable<ImportSuspectListLine> {
    return this.http.put<ImportSuspectListLine>(`${this.appState.baseApiUrl}/vermoedenslijst/import/lines`, importSuspectListLine,  httpOptions);
  }

  updateLines(lines: SuspectListDossier[]): Observable<SuspectListDossier[]> {
    return this.http.put<SuspectListDossier[]>(`${this.appState.baseApiUrl}/vermoedenslijst/import/lines-dossier`, lines, httpOptions);
  }

  import(importSuspectList: ImportSuspectList): Observable<any> {
    return this.http.post<any>(`${this.appState.baseApiUrl}/vermoedenslijst/import`, importSuspectList, httpOptions);
  }

  getGeoLocationFromAddress(street: string, houseNumber:string, city: string, postalCode: string ): Observable<any> {
    const params = {
      street: street,
      houseNumber: houseNumber,
      city: city,
      postalCode: postalCode
    };
    
    return this.http.get<SuspectListDossier[]>(`${this.appState.baseApiUrl}/vermoedenslijst/import/coordinates`, {params, headers: httpOptions.headers});
  }

  getPreviewFile(): void {
    this.http.get(`${this.appState.baseApiUrl}/vermoedenslijst/import/file`, { responseType: "blob" })
      .pipe(take(1))
      .subscribe((file: Blob) => {
        const a = document.createElement("a");
        a.hidden = true;
        a.href = window.URL.createObjectURL(file);
        a.download = `Voorbeeldbestand.csv`;
        a.click();
        a.remove();
        window.URL.revokeObjectURL(a.href);
      });
  }

  optimizeRoute(id: number, ids: number[], latitude: any, longitude: any): Observable<any> {
    return this.http.post<any>(`${this.appState.baseApiUrl}/vermoedenslijst/import/optimize-route/${id}?latitude=${latitude}&longitude=${longitude}`, ids, httpOptions);
  }

  getMaxLocations(): Observable<number> {
    return this.http.get<number>(`${this.appState.baseApiUrl}/vermoedenslijst/import/route/max-locations`, httpOptions);
  }

  handleLines(importId: number, ids: number[]): Observable<boolean> {
    return this.http.put<boolean>(`${this.appState.baseApiUrl}/vermoedenslijst/import/afhandelen/${importId}`, ids, httpOptions);
  }
}
